﻿﻿export interface ICommunicationLogNotesRequest {
    logDateTime: Date;
    notes: string;
}
